/* src/app/stocking/extra-delivery/new-delivery-dialog/new-delivery-dialog.component.css */
.form {
  margin-top: 20px;
}
.mat-column-qty {
  max-width: 80px;
}
.mat-column-max {
  max-width: 60px;
}
.mat-column-product {
  width: 200px;
}
.mat-column-remove {
  max-width: 100px;
}
.summary {
  margin: 50px;
}
button {
  margin: 10px;
}
/*# sourceMappingURL=new-delivery-dialog.component.css.map */
